import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from '../store'
import { Booking } from './types';


interface BookingsState {
  bookings: Booking[];
  dateCollected: Date | null;
  sorting: SortingPreference;
}

export interface SortingPreference {
  column: string;
  direction: 'ASC' | 'DESC';
}

const initialState: BookingsState = {
  bookings: [],
  dateCollected: null,
  sorting: {
    column: 'bookingDate',
    direction: 'DESC',
  }
}

export const bookingsSlice = createSlice({
  name: 'bookings',
  initialState,
  reducers: {
    setBookings: (state, action: PayloadAction<Booking[]>) => {
      state.bookings = action.payload
    },
    setDateCollected: (state, action: PayloadAction<Date>) => {
      state.dateCollected = action.payload
    },
    setSort: (state, action: PayloadAction<SortingPreference>) => {
      state.sorting = action.payload
    },
  },
})

export const { setBookings, setDateCollected, setSort } = bookingsSlice.actions

export const selectBookings = (state: RootState) => state.bookings.bookings
export const selectDateCollected = (state: RootState) => state.bookings.dateCollected
export const selectSortingPreference = (state: RootState) => state.bookings.sorting

export default bookingsSlice.reducer